/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IUpdateWidgetConfigData, WidgetInterface } from '../_models/widgetInterface'
import widgetService from '../_services/widgetService'
import { RootState } from '../_store/store'
import { startLoader, stopLoader } from './loaderSlice'
import { errorToast, successToast } from './toastSlice'
import { handleMessages } from '../_helpers/utilities'

const initialState: WidgetInterface = {
  widgetConfigData: {},
  isLoadingWidgetConfig: false,
}

export const getWidgetConfiguration = createAsyncThunk(
  '/widgetConfiguration',
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await widgetService.getWidgetConfig()
      dispatch(stopLoader())
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)

export const updateWidgetConfiguration = createAsyncThunk(
  '/updateWidgetConfiguration',
  async (params: IUpdateWidgetConfigData, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await widgetService.updateWidgetConfig(params)
      dispatch(successToast(handleMessages(response.message)))
      dispatch(getWidgetConfiguration())
      dispatch(stopLoader())

      return response
    } catch (err: any) {
      dispatch(stopLoader())
      return rejectWithValue(err)
    }
  },
)

export const widgetSlice = createSlice({
  name: 'widget',
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder
      .addCase(getWidgetConfiguration.pending, (state) => {
        state.isLoadingWidgetConfig = true
      })
      .addCase(getWidgetConfiguration.fulfilled, (state, action) => {
        state.widgetConfigData = action.payload.data
        state.isLoadingWidgetConfig = false
      })
      .addCase(getWidgetConfiguration.rejected, (state) => {
        state.isLoadingWidgetConfig = false
      })
  },
})

export const widgetState = (state: RootState) => state.widget
const widgetReducer = widgetSlice.reducer
export default widgetReducer
